import React from 'react';
import { Route } from 'react-router';
import DeliveryZonesScreen from './screens/DeliveryZonesScreen/DeliveryZonesScreen';
import { DispatchingRulesScreen } from './screens/DispatchingRulesScreen/DispatchingRulesScreen';
import { SCREENS } from 'src/constants/screens';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import { Table } from 'src/view/components/Table/Table';

export default class DeliveryManagementScreen extends React.Component<{}, {}> {
  render() {
    return (
      <div className="d-flex flex-column full-width">
        <ScreenHeader
          title="delivery_management"
          options={[
            { path: SCREENS.DELIVERY_ZONES(), title: 'delivery_zones' },
            { path: SCREENS.DISPATCHING_RULES(), title: 'dispatching_rules' },
          ]}
        />
        <Table>
          <>
            <Route path={SCREENS.DELIVERY_ZONES()} component={DeliveryZonesScreen} />
            <Route path={SCREENS.DISPATCHING_RULES()} component={DispatchingRulesScreen} />
          </>
        </Table>
      </div>
    );
  }
}
